import { render, staticRenderFns } from "./PricePointCopy.template.vue?vue&type=template&id=a1a89c92&scoped=true&"
var script = {}
import style0 from "./PricePointCopy.template.vue?vue&type=style&index=0&id=a1a89c92&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1a89c92",
  null
  
)

export default component.exports